import React from "react";

function Error() {
  return (
    <div>
      <p>Opps! Something went wrong!</p>
    </div>
  );
}

export default Error;
